export default {
      id: "oc-res-physicalmachine-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-physicalmachine",
      toString: function () {
        return this.url;
      }
    }